// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ____   ____    .__   __
 * \\   \\ /   /___ |  |_/  |______      ____ ___.__.
 *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |
 *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |
 *    \\___/ \\____/|____/__| (____  /\\___  // ____|
 *                               \\//_____/ \\/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

.tab-flash {
  animation: flash-animation 1.5s;
}

@keyframes flash-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 165, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 165, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 165, 0, 0);
  }
}

.shimmer-effect {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.5s infinite;
  pointer-events: none;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.data-tables {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.data-tables:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

body.editing {
  overflow: hidden;
}

.data-tables {
  transition: opacity 0.3s ease;
}

.data-tables.editing {
  opacity: 0.5;
  pointer-events: none;
}

.editing-active .editable-cell-dialog {
  pointer-events: auto;
}

.tab.closing {
  opacity: 0.5;
  transition: opacity 1s ease-out;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: inherit;
}

.horizontal-scrollbar {
  overflow-x: scroll;
  overflow-y: hidden;
}

.horizontal-scrollbar::-webkit-scrollbar {
  height: 10px;
}

.horizontal-scrollbar::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
}

.horizontal-scrollbar::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.reattach-report-button {
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  padding: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.reattach-report-button:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.reattach-report-button:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.reattach-report-button:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.MuiMenu-paper {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.MuiMenu-paper:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.MuiMenu-list .MuiMenuItem-root {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.MuiMenu-list .MuiMenuItem-root:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/table.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAEF;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAGE;EAAA,kBAA8D;EAA9D,4DAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAA9D;EAAA,kBAA8D;EAA9D,yDAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAGhE;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAGE;EAAA,sBAAyI;EAAzI,iBAAyI;EAAzI,sBAAyI;EAAzI,4DAAyI;EAAzI,gBAAyI;EAAzI,oBAAyI;EAAzI;AAAyI;;AAAzI;EAAA,oBAAyI;EAAzI;AAAyI;;AAAzI;EAAA,sBAAyI;EAAzI,yDAAyI;EAAzI,oBAAyI;EAAzI;AAAyI;;AAAzI;EAAA,oBAAyI;EAAzI;AAAyI;;AAIzI;EAAA,kBAAgC;EAAhC;AAAgC;;AAAhC;EAAA,kBAAgC;EAAhC;AAAgC;;AAIhC;EAAA,oBAAuC;EAAvC;AAAuC;;AAAvC;EAAA,oBAAuC;EAAvC;AAAuC","sourcesContent":["/*\n * ____   ____    .__   __\n * \\   \\ /   /___ |  |_/  |______      ____ ___.__.\n *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |\n *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |\n *    \\___/ \\____/|____/__| (____  /\\___  // ____|\n *                               \\//_____/ \\/\n *\n * Copyright (c) 2017-2025 Voltagy. All rights reserved.\n * https://voltagy.com\n *\n * PROPRIETARY AND CONFIDENTIAL\n *\n * This source code is the proprietary and confidential property of Voltagy.\n * Unauthorized copying, transfer, or use of this file, via any medium, is\n * strictly prohibited without the express written permission of Voltagy.\n *\n * The receipt or possession of this source code and/or related information\n * does not convey or imply any right to use it, reproduce it, disclose its\n * contents, or to manufacture, use, or sell anything that it may describe.\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE\n * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE\n * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\n * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF\n * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS\n * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN\n * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)\n * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE\n * POSSIBILITY OF SUCH DAMAGE.\n *\n */\n\n.tab-flash {\n  animation: flash-animation 1.5s;\n}\n\n@keyframes flash-animation {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 165, 0, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(255, 165, 0, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(255, 165, 0, 0);\n  }\n}\n\n.shimmer-effect {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shimmer 1.5s infinite;\n  pointer-events: none;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.data-tables {\n  @apply bg-white text-gray-900 dark:bg-gray-800 dark:text-white;\n}\n\nbody.editing {\n  overflow: hidden;\n}\n\n.data-tables {\n  transition: opacity 0.3s ease;\n}\n\n.data-tables.editing {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.editing-active .editable-cell-dialog {\n  pointer-events: auto;\n}\n\n.tab.closing {\n  opacity: 0.5;\n  transition: opacity 1s ease-out;\n}\n\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: inherit;\n}\n\n.horizontal-scrollbar {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n\n.horizontal-scrollbar::-webkit-scrollbar {\n  height: 10px;\n}\n\n.horizontal-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 5px;\n}\n\n.horizontal-scrollbar::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.reattach-report-button {\n  @apply text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white p-1 border rounded border-gray-300 dark:border-gray-600;\n}\n\n.MuiMenu-paper {\n  @apply bg-white dark:bg-gray-700;\n}\n\n.MuiMenu-list .MuiMenuItem-root {\n  @apply text-gray-900 dark:text-gray-100;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
